<template>
  <VerificationForm :skip-button="false" :loader="!loaded">
    <template #title>{{ $t('unableAddPhoneLabel') }}</template>
    <template #description>
      <span v-html="description"></span>
    </template>
    <template #actions>
      <SButton wide @click="onGoToClick">{{ $t('toLKButtonLabel') }}</SButton>
      <SButton wide variant="secondary" @click="onSupportClick">{{ $t('techSupportButtonLabel') }}</SButton>
    </template>
  </VerificationForm>
</template>

<script setup lang="ts">
import { SButton } from '@synergy/ui-kit-vue3'
import { computed, onMounted, ref } from 'vue'
import { useTranslate } from '@tolgee/vue'
import { useRoute } from 'vue-router'

//Components
import VerificationForm from '@/components/VerrificationForm/VerificationForm.vue'

// Helpers
import { setAuthForm } from '@/api/api'

///common/synergy_help
import ENV from '@/env.json'

const { t } = useTranslate()
const route = useRoute()

const loaded = ref(true)

const error_status = ref<number | null>(null)

const description = computed(() => {
  console.log(typeof error_status.value)
  switch (error_status.value) {
    case 409:
      return t.value('unavailablePhoneError')
    default:
      return t.value('tempServerError')
  }
})

function onGoToClick() {
  const redirect_uri = (route.query?.redirectUri as string) || null
  const token = (route.query?.token as string) || null

  if (token) {
    setAuthForm(token).then(() => {
      if (redirect_uri) {
        window.location.href = redirect_uri
      } else {
        window.location.href = ENV.LK__API_URL
      }
    })
  } else {
    if (redirect_uri) {
      window.location.href = redirect_uri
    } else {
      window.location.href = ENV.LK__API_URL
    }
  }
}

function onSupportClick() {
  const token = (route.query?.token as string) || null
  if (token) {
    setAuthForm(token).then(() => {
      if (ENV.LK__API_URL) {
        window.location.href = ENV.LK__API_URL + '/common/synergy_help'
      }
    })
  }
}

onMounted(() => {
  error_status.value = Number(route.params?.code) || 0
})
</script>

<style scoped lang="scss">
.email-confirmation {
  display: flex;
  flex-direction: column;
  gap: 36px;
  max-width: 540px;
  width: 100%;
  border-radius: 4px;
  padding: 40px;
  overflow: hidden;
  box-sizing: border-box;

  box-shadow: 0px 6px 18px 0px #00000017;
}

.email-confirmation-header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  &__logo {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: auto;
    height: 48px;
  }
}

.email-confirmation-body {
  display: flex;
  flex-direction: column;
  gap: 12px;

  &__label {
    font-weight: 500;
    font-size: 28px;
    line-height: 36px;
    letter-spacing: 0%;
    text-align: center;
  }
}

.email-confirmation-description {
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0%;
  text-align: center;

  &__phone-number {
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 0%;
    text-align: center;
  }
}

.email-confirmation-actions {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;

  &__timer {
    white-space: nowrap;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 0%;
    text-align: center;
    vertical-align: middle;
    color: var(--color-text-secondary);
  }
}

.verification-preloader {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 246px;
}

.skip-button {
  display: flex;
  background-color: transparent;
  padding: 0;
  margin: 0;
  border: none;
  color: #ed131c;
  cursor: pointer;

  &__label {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-weight: 500;
    font-size: 18px;
    line-height: 18px;
    letter-spacing: 0%;
  }

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
  }
}

.invalid {
  // border-color: var(--color-text-accent) !important;
  &--element-border {
    border-radius: 4px;
    border: 1px var(--color-text-accent) solid !important;
  }

  &--text {
    color: var(--color-icon-accent-dangerous) !important;
  }

  &--card-border {
    border-color: var(--color-icon-accent-dangerous) !important;
  }
}
</style>
